import React,{useState} from 'react'
export default function Contact() {
  const [Text,SetText] = useState('')
  const [Email,SetEmail] = useState('')
  return (
    <>
     <div className='bg-gradient-to-t from-[#3D0000] to-[#000000]  text-xl p-10 text-white font-[Roboto Condensed] pt-16 pb-16' id='contact'>
        <h1 className=' text-5xl text-center font-[Poppins] py-8'>Contact Us</h1>
        <div className=' lg:flex lg:justify-center lg:gap-72 border-black pt-16'>
        <form action="https://formspree.io/f/xnqyvyyb" method='POST' className=' flex flex-col justify-center gap-8 lg:gap-9 lg:pl-24 '>
        <input type="text" placeholder='Username' name='Username' required className=' p-3 outline-none bg-gray-500 text-xl font-[Poppins] rounded-3xl' onChange={(e)=>{SetEmail(e.target.value)}}/>
        <input type="email" placeholder='Your email' className=' p-3 outline-none bg-gray-500 text-xl font-[Poppins] rounded-3xl' onChange={(e)=>{SetEmail(e.target.value)}}/>
        <textarea type="text" placeholder='Any Suggestions/Complains?' rows={10} className=' p-3 outline-none bg-gray-500 text-xl font-[Poppins] rounded-3xl' onChange={(e)=>{SetText(e.target.value)}}/>
        <button className=' bg-[#da1010] px-5 py-4 w-full text-white text-lg rounded-full hover:bg-[#3D0000]  my-6' type='submit' value='send'> Submit </button>
        </form>
        <img src="https://images.unsplash.com/photo-1591504771094-a1ca4de142d7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1yZWxhdGVkfDd8fHxlbnwwfHx8fHw%3D&auto=format&fit=crop&w=500&q=60" alt="..." className=' rounded-[3.5rem] pt-16 lg:w-96 w-full lg:pl-0 lg:pt-0 h-96 lg:h-full' />
        </div>
        </div>
    </>
  )
}
